import React from 'react';

const Filtering = ({ selectedPrice, onPriceChange }) => {
  const priceOptions = ['All', 'Under $2000', 'Under $4000', 'Under $6000'];

  return (
    <div className="mb-6">
      <label htmlFor="priceFilter" className="text-gray-700 font-medium mr-4">Filter by Price:</label>
      <select
        id="priceFilter"
        value={selectedPrice}
        onChange={(e) => onPriceChange(e.target.value)}
        className="p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-green-500"
      >
        {priceOptions.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Filtering;